export default "/images/a8b9330502094169f4ef158c196894fe.avif";